export default {
  tabs: {
    present: "Current",
    history: "History",
    screening: "Filter",
  },
  form: {
    readStatus: "Read",
    assignmentStatus: "Assignment",
    agentName: "Agent",
    vipLevel: "VIP",
    all: "All",
    unread: "Unread",
    read: "Read",
    unassigned: "Unassigned",
    assigned: "Assigned",
    user: "User ID",
    totalMessages: "{count} Messages",
    inputPlaceholder: "Enter text",
    replyStatus: "Reply",
  },
  action: {
    search: "Search",
    reset: "Reset",
  },
  serviceList: {
    allocation: "Auto-assign",
    configuration: "Settings",
    blockUser: "Block",
    transferChat: "Transfer",
    bulkTransfer: "Bulk Ops",
    transferService: "Transfer",
    bulkClose: "Bulk Close",
    bulkOpen: "Bulk Open",
    all: "Select All",
    endConversation: "End chat",
    platform: "Platform",
    balance: "Balance",
    total_recharge_amount: "Total recharge",
    deposit_withdrawal_difference: "Deposit/Withdrawal diff",
    subordinate_recharge_count: "Subordinate recharges",
    subordinate_recharge_amount: "Subordinate recharge total",
    id: "ID",
    noData: "Select a chat to start",
    moreRecords: "Load more",
    noMoreRecords: "No more records",
    upload: "Send image",
    image: "Image",
    video: "Video",
    file: "File",
    score: "Score",
    uploadVideo: "Send video",
    uploadFile: "Send file",
    videoTooLarge: "Max size 100MB",
    assignAgent: "Assign agent",
    closeConversation: "Close chat",
    allocationSuccess: "Assigned",
    closeSession: "Close this chat?",
    closeSelected:
      "Do you want to close the selected conversations？(Total: {total})",
    closeSuccess: "Closed",
    unReadMessage: "Do you want to mark this session as unread?",
    noCurrentConversation: "No chats",
    selectServiceForAllocation: "Select agent to assign",
    userRating: "Rating",
    serviceFeedback: "{name} was patient and quick!",
    recall: "Delete",
    copyText: "Copy text",
    edit: "Edit",
    copyImage: "Copy image",
    downloadImage: "Download image",
    downloadFile: "Download file",
    reply: "Reply",
    editLabel: "Edit Label",
    messageUnRead: "Message unread",
    selectConversation: "Please select a conversation",
    mobile: "Mobile Number",
    isGuest: "Is Guest",
    selectFilterRequired: "Please select a filter condition",
    reverse: "Reverse Order",
    toggleSuccess: "Toggled successfully",
  },
  distribution: {
    autoAssign: "Auto",
    assignType: "Conversation type",
    assign: "Agent",
    all: "All",
    existing: "Existing",
    new: "New",
    startAllocation: "Start",
    agentSelect: "Please select an agent",
    enableAutoAssignment: "Enable auto",
  },
  time: {
    yesterday: "Yesterday",
    sunday: "Sun",
    monday: "Mon",
    tuesday: "Tue",
    wednesday: "Wed",
    thursday: "Thu",
    friday: "Fri",
    saturday: "Sat",
    date_format: "{month}/{day}",
  },
};
